/*
 * VPDB - Virtual Pinball Database
 * Copyright (C) 2019 freezy <freezy@vpdb.io>
 *
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 * Modified for sigmashake-pinball by SigmaShake, 2026.
 */

import type { ItemFrame } from "../../../shared/contracts";
import { ItemState } from "../../core/item-state";

export class SpinnerState extends ItemState {
  /**
   * Angle in rad
   */
  public angle: number = 0;
  public showBracket: boolean = true;

  public constructor(name: string, angle: number, showBracket: boolean, isVisible: boolean) {
    super();
    this.name = name;
    this.angle = angle;
    this.showBracket = showBracket;
    this.isVisible = isVisible;
  }

  public override toFrame(): ItemFrame {
    return { name: this.name, kind: "spinner", angle: this.angle, visible: this.isVisible };
  }
}
